import React       from 'react'

const renderFileUpload = ({ input: {value: omitValue, ...inputProps }, showPreviewImg, meta: omitMeta, ...props }) => (
  <input type='file' {...inputProps} id="fileUpload" {...props} onChange={e => showPreviewImg(e)} />
)

export default renderFileUpload;
